import type { LotteryPurchasesConfig } from '../../lotteryPurchases.types.ts';
import { ROUTES } from './routes/routes.ts';

const LOTTERY_PURCHASES: LotteryPurchasesConfig = {
  showsTicketStateSwitcher: true,
  showsLegacySiteNotification: true,
  emptyStateCtaHref: ROUTES.LOTTO.DISCOVERY,
};

export { LOTTERY_PURCHASES };
